import * as R from 'ramda';
import React, { useState } from 'react';
// components
import { TextComponent } from '../../../components/text';
import { InputWithHandlers } from '../../../components/input-with-handlers';
// helpers/constants
import * as G from '../../../helpers';
// icons
import * as I from '../../../svgs';
// ui
import { Flex, IconWrapper } from '../../../ui';
//////////////////////////////////////////////////

const textOptions = {
  fontSize: 11,
  p: '4px 10px',
  fontWeight: 700,
  borderRadius: 15,
  cursor: 'pointer',
  display: 'inline-block',
};

const offWhiteColor = G.getTheme('colors.offWhite');
const borderGrayColor = G.getTheme('colors.borderGray');
const mainDarkColor = G.getTheme('colors.dark.mainDark');

const data = ['titles:all', 'titles:read', 'titles:unread'];
const type = {'titles:all': '', 'titles:read': 'true', 'titles:unread': 'false' };

const FilterRead = ({ handleChangeFilter }) => {
  const [active, setActive] = useState('');

  const handleClickFilter = (itemType) => {
    setActive(itemType);
    handleChangeFilter(itemType);
  };

  return (
    <Flex p='4px' gap='5px' borderRadius={10} bg={offWhiteColor}>
      {
        data.map((item, index) => {
          const itemType = G.getPropFromObject(item, type);
          const isActive = R.equals(active, itemType);

          return (
            <TextComponent
              key={index}
              {...textOptions}
              onClick={() => handleClickFilter(itemType)}
              bg={isActive ? G.getTheme('colors.white') : 'none'}
              color={isActive ? mainDarkColor : G.getTheme('colors.titleGrey')}
            >
              {G.getWindowLocale(item)}
            </TextComponent>
          );
        })
      }
    </Flex>
  );
};

export const NotificationHeader = ({ onHidePopup, filterString, handleChangeFilter }) => (
  <Flex p={15} borderBottom='1px solid' borderColor={borderGrayColor} justifyContent='space-between'>
    <Flex gap='5px'>
      <IconWrapper height={15} width='max-content'>{I.bellIcon(mainDarkColor)}</IconWrapper>
      <TextComponent fontSize={18} fontWeight={600} color={mainDarkColor}>
        {G.getWindowLocale('titles:notifications', 'Notifications')}
      </TextComponent>
    </Flex>
    <FilterRead handleChangeFilter={handleChangeFilter} />
    <InputWithHandlers
      value={filterString}
      onChange={handleChangeFilter}
      inputBorderColor={borderGrayColor}
      placeholder={`${G.getWindowLocale('titles:search', 'Search')}...`}
      styles={{
        px: 10,
        width: 135,
        height: 30,
        fontSize: 12,
        borderRadius: 10,
        border: '1px solid',
        color: mainDarkColor,
      }}
    />
    <Flex
      width={25}
      height={25}
      cursor='pointer'
      borderRadius='6px'
      bg={offWhiteColor}
      onClick={onHidePopup}
      justifyContent='center'
    >
      {I.closeIcon(mainDarkColor, 10, 10)}
    </Flex>
  </Flex>
);
